import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TProps, IDeps } from './models';
import { UrlMapperContext as Component } from './component';

/**
 * Provider: Провайдер нужен для виджета UrlMapper
 * */
export const SmePartnersCommonUrlMapperContext = createWidget<IDeps, TProps>({})(Component);
